import React, { useContext } from 'react';
import { LangContext } from '../../contexts/langContext';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';
import { default_design } from '../../static/default_design';
import { Var } from '../Edu/Variables';
import { Avatar } from '../UiKit/Avatar';
import { AvatarName } from '../UiKit/AvatarName';
import { getColor, getMars, getMoon } from '../utilsDesign';

const PHS_VARS = ['diet', 'env', 'motivation', 'perspective', 'trauma', 'love'];

const getPhsValue = (variable, design) => {
  if (!design) return null;
  if (variable === 'trauma') return getMars(design, 'des') ?? null;
  if (variable === 'love') return getMoon(design, 'des') ?? null;
  const getter = getColor[variable];
  return getter ? (getter(design) ?? null) : null;
};

const PhsCompat = ({ variable, designA, designB, $ui }) => {
  const valueA = getPhsValue(variable, designA);
  const valueB = getPhsValue(variable, designB);
  if (valueA == null || valueB == null) return null;

  const same = String(valueA) === String(valueB);
  const status = same ? 'match' : 'neutral';
  const statusLabel = same ? $ui('phs_compat_same') : $ui('phs_compat_diff');
  const detailLabel = same
    ? $ui(`phs_compat_${variable}_same`)
    : $ui(`phs_compat_${variable}_diff`);

  return (
    <div className={`x_penta_compat ${status ? `x_penta_compat--${status}` : ''}`}>
      <span className="x_penta_compat_line x_penta_compat_line--1"></span>
      <div className={`x_penta_compat_inner x_penta_compat_inner--${status}`}>
        <span className="x_penta_compat_label">
          {/* <b>{statusLabel}</b> */}
          <span className="x_penta_compat_pair">{detailLabel}</span>
        </span>
      </div>
      <span className="x_penta_compat_line x_penta_compat_line--2"></span>
    </div>
  );
};

export const PentaPHS = React.memo((props) => {

  const {
    videos = false,
    penta
  } = { ...props };

  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const $ui = context.$ui;

  const design1 = penta.members[0] ? penta.members[0].avatar.design : default_design;
  const design2 = penta.members[1] ? penta.members[1].avatar.design : default_design;

  const compareColumnWidth = `${(100 / penta.members.length)}%`;
  const showCompat = penta.members.length === 2;

  return (
    <>

      <div className="x_edu_content_title x_edu_content_title--group x_edu_content_title--sticky">
        <div className='x_edu_content_h x_edu_content_h--2'>
          {$ui('penta_phs_title')}
        </div>
      </div>

      <div className="x_edu_content x_edu_content--penta x_edu_content--penta_phs">
        <div className="x_edu_content_inner ">
          <div className="_fv _fgap04">
            <div className="x_edu_penta_persons" >
              {penta.members.map((oneMember) => {
                return (
                  <div
                    key={`phs_${oneMember.avatar.token}`}
                    className='x_edu_penta_oneperson'
                    style={{ flexBasis: compareColumnWidth }}
                  >
                    <div className="x_edu_channels">

                        <span className='x_ava_inline0'>
                          <span className='x_ava_inline' style={{ display: 'inline-flex' }}>
                            <Avatar style={{ fontSize: '1em' }} avatar={oneMember.avatar} /></span>
                          <span 
                          style={{ maxWidth: `calc(100% / ${penta.members.length}) - ${penta.members.length} * 1em` }}
                          className={`x_ava_inline_name x_ava_inline_name--${oneMember.avatar.design.type.toLowerCase()}`}>
                            <AvatarName avatar={oneMember.avatar} />
                          </span>
                        </span>

                    </div>
                  </div>
                )
              })}
            </div>



            <div className="_fv _fgap1">
              {PHS_VARS.map(oneVar => {
                  return (
                    <React.Fragment key={`phs_${penta.token}_${oneVar}`}>
                      <div className="x_edu_penta_persons">
                        {penta.members.map((oneMember) => {
                          const design = oneMember.avatar.design;
                          return (<div
                            className='x_edu_penta_oneperson _fgap1'
                            key={oneMember.avatar.token}
                            style={{ flexBasis: compareColumnWidth }}
                          >

                            <Var
                              design={design}
                              variable={oneVar}
                              className='x_edu_penta_oneperson'
                              addClassName='100'
                              advanced={true}
                              videos={videos}
                            />
                          </div>)
                        })}
                      </div>

                      {showCompat && (
                        <PhsCompat
                          variable={oneVar}
                          designA={design1}
                          designB={design2}
                          $ui={$ui}
                        />
                      )}
                    </React.Fragment>
                  )
                })}
            </div>
            </div>



        </div>

      </div>

    </>
  )
})
